import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/components/ThemeProvider";
import Layout from "@/components/Layout";
import ProtectedRoute from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import LearnGerman, { Courses } from "@/pages/Courses";
import LessonDetail from "@/pages/LessonDetail";
import LevelTest from "@/pages/LevelTest";
import Tools from "@/pages/Tools";
import ToolDetail from "@/pages/ToolDetail";
import { WorkGerman, SectorDetail } from "@/pages/Work";
import { Guides, Article } from "@/pages/Guides";
import Glossary from "@/pages/Glossary";
import Pricing from "@/pages/Pricing";
import Conversation from "@/pages/Conversation";
import Dashboard from "@/pages/Dashboard";
import Review from "@/pages/Review";
import Admin from "@/pages/Admin";
import Editorial from "@/pages/Editorial";
import { Register, Login } from "@/pages/Auth";
import { Contact, FaqPage } from "@/pages/Contact";
import { About, EditorialMethodology, CorrectionsPolicy, LivingInSwitzerland, Privacy, Cookies, Terms, Affiliation, LegalNotice, EditorialTeam } from "@/pages/Content";
import { NotFound, ServerError } from "@/pages/Errors";

const Page = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <Routes>
            {/* Standalone (own layout) */}
            <Route path="/prueba-de-nivel" element={<LevelTest />} />
            <Route path="/registro" element={<Register />} />
            <Route path="/iniciar-sesion" element={<Login />} />
            <Route path="/error" element={<ServerError />} />

            {/* Public with Layout */}
            <Route path="/" element={<Page><Home /></Page>} />
            <Route path="/aprender-aleman" element={<Page><LearnGerman /></Page>} />
            <Route path="/cursos" element={<Page><Courses /></Page>} />
            <Route path="/cursos/:slug" element={<Page><Courses /></Page>} />
            <Route path="/lecciones/:slug" element={<Page><LessonDetail /></Page>} />
            <Route path="/herramientas" element={<Page><Tools /></Page>} />
            <Route path="/herramientas/:slug" element={<Page><ToolDetail /></Page>} />
            <Route path="/aleman-para-trabajar" element={<Page><WorkGerman /></Page>} />
            <Route path="/sectores/:slug" element={<Page><SectorDetail /></Page>} />
            <Route path="/vivir-en-suiza" element={<Page><LivingInSwitzerland /></Page>} />
            <Route path="/guias" element={<Page><Guides /></Page>} />
            <Route path="/guias/:slug" element={<Page><Article /></Page>} />
            <Route path="/glosario" element={<Page><Glossary /></Page>} />
            <Route path="/precios" element={<Page><Pricing /></Page>} />
            <Route path="/quienes-somos" element={<Page><About /></Page>} />
            <Route path="/metodologia-editorial" element={<Page><EditorialMethodology /></Page>} />
            <Route path="/politica-de-correcciones" element={<Page><CorrectionsPolicy /></Page>} />
            <Route path="/contacto" element={<Page><Contact /></Page>} />
            <Route path="/preguntas-frecuentes" element={<Page><FaqPage /></Page>} />
            <Route path="/privacidad" element={<Page><Privacy /></Page>} />
            <Route path="/cookies" element={<Page><Cookies /></Page>} />
            <Route path="/terminos" element={<Page><Terms /></Page>} />
            <Route path="/afiliacion" element={<Page><Affiliation /></Page>} />
            <Route path="/aviso-legal" element={<Page><LegalNotice /></Page>} />
            <Route path="/autores/:slug" element={<Page><EditorialTeam /></Page>} />

            {/* Protected */}
            <Route path="/panel" element={<ProtectedRoute><Page><Dashboard /></Page></ProtectedRoute>} />
            <Route path="/repaso" element={<ProtectedRoute><Page><Review /></Page></ProtectedRoute>} />
            <Route path="/conversaciones" element={<ProtectedRoute><Page><Conversation /></Page></ProtectedRoute>} />
            <Route path="/editorial" element={<ProtectedRoute roles={["editor", "reviewer", "admin"]}><Page><Editorial /></Page></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><Page><Admin /></Page></ProtectedRoute>} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
